<template>
  <div>
    <a-form
      ref="formRef"
      layout="vertical"
      :model="form"
    >
      <a-card :bordered="false">
        <!-- 目标内容 -->
        <a-form-item
          ref="objectiveContent"
          name="content"
          :rules="{
            type: 'string',
            required: true,
            message: $t('okr.formRules.required.objective'),
            trigger: 'blur'
          }"
          :auto-link="false"
        >
          <MentionTextarea
            v-model:value="form.content"
            :placeholder="$t('okr.editObjectiveDialog.contentPlaceholder')"
            :mentioned-user-ids="form.mentionUserIds"
            search-range="ALL"
            :form-item-ref="$refs.objectiveContent"
          />
          <!-- <template #label>
            <a-space>
              <IconFont
                type="iconmubiao"
                :style="{ fontSize: '20px' }"
              />
              {{ $t('shared.objective') }}
            </a-space>
          </template> -->
        </a-form-item>
        <!-- 是否为财务目标 -->
        <a-form-item
          :label="$t('okr.editObjectiveDialog.whetherIsAboutFinance')"
          name="isFinancial"
          :rules="{
            type: 'boolean',
            required: true,
            message: $t('okr.formRules.required.objective'),
            trigger: 'blur'
          }"
        >
          <a-radio-group v-model:value="form.isFinancial">
            <a-radio :value="true">
              {{ $t('okr.radio.yes') }}
            </a-radio>
            <a-radio :value="false">
              {{ $t('okr.radio.no') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <!-- 权重 -->
        <a-form-item
          :label="$t('shared.proportion')"
          name="weight"
          :rules="{
            type: 'number',
            required: true,
            message: $t('okr.formRules.required.shared'),
            trigger: 'blur'
          }"
        >
          <a-input-number
            v-model:value="form.weight"
            name="weight"
            :min="0"
            :max="100"
            :step="1"
            :precision="0"
            class="input"
            :formatter="value => `${value}`"
          />
          <span class="after">/100</span>
        </a-form-item>
        <div class="title">
          {{ $t('okr.list.performanceIndicators') }}
        </div>
        <!-- SAB 考核标准相关字段 -->
        <a-form-item
          :label="$t('okr.editObjectiveDialog.hideOrNot')"
          name="performanceIsHide"
          :rules="{
            type: 'boolean',
            required: true,
            message: $t('okr.formRules.required.objective'),
            trigger: 'blur'
          }"
        >
          <a-radio-group v-model:value="form.performanceIsHide">
            <a-radio :value="true">
              {{ $t('okr.radio.hide') }}
              <a-popover placement="top">
                <template #content>
                  <span>{{ $t('okr.editObjectiveDialog.hideOrNotTip') }}</span>
                </template>
                <span class="tip">?</span>
              </a-popover>
            </a-radio>
            <a-radio :value="false">
              {{ $t('okr.radio.not') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          :label="`${$t('okr.list.superior')}（${$t('okr.list.superiorPlaceholder')}）`"
          :name="['performanceObjective', 'superior']"
          :rules="{
            type: 'string',
            required: true,
            message: $t('okr.formRules.required.objective'),
            trigger: 'blur'
          }"
        >
          <a-textarea
            v-model:value="form.performanceObjective.superior"
            :placeholder="$t('okr.list.placeholder')"
            :auto-size="{ minRows: 3, maxRows: 6 }"
          />
        </a-form-item>
        <a-form-item
          :label="`${$t('okr.list.excellent')}（${$t('okr.list.excellentPlaceholder')}）`"
          :name="['performanceObjective', 'excellent']"
          :rules="{
            type: 'string',
            required: true,
            message: $t('okr.formRules.required.objective'),
            trigger: 'blur'
          }"
        >
          <a-textarea
            v-model:value="form.performanceObjective.excellent"
            :placeholder="$t('okr.list.placeholder')"
            :auto-size="{ minRows: 3, maxRows: 6 }"
          />
        </a-form-item>
        <a-form-item
          :label="$t('okr.list.target')"
          :name="['performanceObjective', 'target']"
          :rules="{
            type: 'string',
            required: true,
            message: $t('okr.formRules.required.objective'),
            trigger: 'blur'
          }"
        >
          <a-textarea
            v-model:value="form.performanceObjective.target"
            :placeholder="$t('okr.list.placeholder')"
            :auto-size="{ minRows: 3, maxRows: 6 }"
          />
        </a-form-item>
        <!--        <a-form-item-->
        <!--          ref="objectiveWeight"-->
        <!--          :label="$t('shared.weight')"-->
        <!--          name="weight"-->
        <!--          :rules="{-->
        <!--            type: 'number',-->
        <!--            required: true,-->
        <!--            validator: objectiveWeightValidator,-->
        <!--            trigger: 'blur'-->
        <!--          }"-->
        <!--          :auto-link="false"-->
        <!--        >-->
        <!--          <a-input-number-->
        <!--            :value="form.weight"-->
        <!--            :formatter="value => `${value}%`"-->
        <!--            :disabled="true"-->
        <!--          />-->
        <!--        </a-form-item>-->
      </a-card>
      <a-card
        v-for="(keyResult, index) in form.keyResults"
        :key="keyResult.id"
        :bordered="false"
      >
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item
              :ref="setKeyResultContentRef"
              :name="['keyResults', index, 'content']"
              :rules="{
                type: 'string',
                required: true,
                message: $t('okr.formRules.required.keyResult'),
                trigger: 'blur'
              }"
              :auto-link="false"
            >
              <MentionTextarea
                v-model:value="keyResult.content"
                :placeholder="$t('okr.editKeyResultDialog.contentPlaceholder')"
                :mentioned-user-ids="keyResult.mentionUserIds"
                :form-item-ref="keyResultContentRefs[index]"
              />
              <template #label>
                <a-space>
                  <KeyResultIcon :size="16" />
                  {{ $t('shared.keyResult') }} {{ index + 1 }}
                  <DeleteOutlined @click="deleteKeyResult(keyResult.id)" />
                </a-space>
              </template>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <a-card :bordered="false">
        <CreateButton
          :text="$t('okr.list.createKeyResult')"
          icon-name="icontianjiaKR1"
          :style="{ backgroundColor: '#F8F9FF' }"
          @click="addNewKeyResult()"
        />
      </a-card>
    </a-form>
    <FormAction
      :loading="loading"
      :can-close="canClose"
      @cancel="$emit('cancel')"
      @save="save()"
    />
  </div>
</template>

<script>
import { ref, reactive, onBeforeUpdate, watch, toRaw } from 'vue'
import { useI18n } from 'vue-i18n'
import { DeleteOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'

import { replaceStr2Html } from '@/utils/line-break'
import { createObjective } from '@/api/okr'
import { editObjectiveAuth, removeObjectiveAuth } from '@/api/auth'
import useMention from '@/composables/use-mention'
import CreateButton from '@/components/CreateButton'
import KeyResultIcon from '@/components/KeyResultIcon'
import FormAction from './FormAction'
// import WeightInput from '@/components/WeightInput'
import MentionTextarea from '@/components/MentionTextarea'

export default {
  name: 'ObjectiveForm',
  components: {
    DeleteOutlined,
    KeyResultIcon,
    CreateButton,
    FormAction,
    // WeightInput,
    MentionTextarea
  },
  props: {
    okrListId: {
      type: Number,
      default: null
    },
    canClose: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:can-close', 'objective-created', 'cancel'],
  setup (props, { emit }) {
    const { t } = useI18n()
    const { getFormattedUserIds, getAddUserIds, getRmUserIds } = useMention()
    const formRef = ref()
    const form = reactive({
      content: '',
      weight: 0,
      mentionUserIds: [],
      keyResults: [],
      performanceIsHide: true,
      isFinancial: false,
      performanceObjective: {
        superior: '',
        excellent: '',
        target: ''
      }
    })
    const keyResultContentRefs = ref([])
    const loading = ref(false)
    const originalMentionUserIds = [...toRaw(form.mentionUserIds)]

    watch(form, () => {
      emit('update:can-close', false)
    })

    onBeforeUpdate(() => {
      keyResultContentRefs.value = []
    })

    function addNewKeyResult () {
      form.keyResults.push({
        id: Date.now(),
        content: '',
        mentionUserIds: []
      })
    }

    function deleteKeyResult (id) {
      form.keyResults = form.keyResults.filter(keyResult => keyResult.id !== id)
    }

    async function save () {
      loading.value = true
      try {
        await formRef.value.validate()
      } catch (_) {
        loading.value = false
        return
      }

      const data = {
        okrlist_id: props.okrListId,
        content: replaceStr2Html(form.content),
        weight: form.weight,
        is_financial: form.isFinancial,
        performance_is_hide: form.performanceIsHide,
        performance_objective: JSON.stringify({
          superior: form.performanceObjective.superior,
          excellent: form.performanceObjective.excellent,
          target: form.performanceObjective.target
        }),
        key_results: form.keyResults.map((kr, index) => [
          0,
          0,
          {
            content: replaceStr2Html(kr.content),
            // weight:
            //   index === form.keyResults.length - 1
            //     ? 100 - Math.floor(100 / form.keyResults.length) * index
            //     : Math.floor(100 / form.keyResults.length),
            progress: 0,
            state_id: 1,
            // confidence_index: 5,
            mention_user_ids: getFormattedUserIds(kr.content, kr.mentionUserIds)
          }
        ]),
        mention_user_ids: getFormattedUserIds(form.content, form.mentionUserIds)
      }

      const addUserIds = getAddUserIds(originalMentionUserIds, data.mention_user_ids[0][2])
      const rmUserIds = getRmUserIds(originalMentionUserIds, data.mention_user_ids[0][2])

      createObjective(data).then(objectiveId => {
        addAuth(objectiveId, addUserIds)
        removeAuth(objectiveId, rmUserIds)
        loading.value = false
        message.success(t('okr.createObjectiveDialog.successMessage'))
        emit('objective-created', objectiveId)
      }).catch(e => {
        loading.value = false
      })
    }

    // function objectiveWeightValidator (rule, value) {
    //   if (value !== 100) {
    //     return Promise.reject('所有关键结果的总权重之和应该是100')
    //   }
    //   return Promise.resolve()
    // }

    function addAuth (objectiveId, addUserIds) {
      if (addUserIds.length === 0) {
        return
      }
      editObjectiveAuth(objectiveId, addUserIds).then(res => {
        console.log(res)
      })
    }

    function removeAuth (objectiveId, rmUserIds) {
      if (rmUserIds.length === 0) {
        return
      }
      removeObjectiveAuth(objectiveId, rmUserIds).then(res => {
        console.log(res)
      })
    }

    function setKeyResultContentRef (el) {
      if (el) {
        keyResultContentRefs.value.push(el)
      }
    }

    return {
      form,
      addNewKeyResult,
      deleteKeyResult,
      save,
      // objectiveWeightValidator,
      formRef,
      setKeyResultContentRef,
      keyResultContentRefs,
      loading
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-card:first-child) {
  margin-top: 24px;
}

:deep(.ant-card) {
  box-shadow: none !important;
}

:deep(.ant-card-body) {
  padding-top: 0;
  padding-bottom: 0;
}
.title {
  margin-bottom: 18px;
  font-weight: 700;
}

:deep(.ant-form-item-label) {
  label {
    color: rgba(0, 0, 0, 0.56);
  }
}

.tip {
  color: red;
}

.after {
  padding-left: 6px;
}
</style>
